import { borderRadius, margin, padding } from "polished";
import defaultImage from "../assets/expligo_wp2.png"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { IconButton } from "./buttons";
import { useState } from "react";
import avatar1 from "../assets/preview_target.webp";
import avatar2 from "../assets/preview_target-2.webp";
import avatar3 from "../assets/preview_target-3.webp";
export function VideoPlayer({ videoSrc, audio,audioSrc, className = "", avatarBackground, avatar, position }) {

  const avatarSrc = {1:avatar1, 2:avatar2, 3:avatar3}[avatar?.id] || "";
  const spotlightPosition = position === 1 ? "30% 50%" : position === 2 ? "50% 50%" : "70% 50%";
  const leftColor = avatarBackground?.colors?.[0];
  const centerColor = avatarBackground?.colors?.[1];
  const rightColor = leftColor;
  const backgroundGradient = `radial-gradient(circle 40rem at ${spotlightPosition}, ${leftColor} 0%, ${centerColor} 50%, ${rightColor} 100%)`;
  const avatarAlign = position === 1 ? "flex-start" : position === 2 ? "center" : "flex-end";

  return videoSrc ? (
    <VerticalLayout className="relative phone-avatar-video avatar-video">
      <video   onClick={(event) => event.stopPropagation()} controls className={`standard-shadow ${className}`} src={videoSrc} />
    </VerticalLayout>
  ) : (
    <VerticalLayout className={`relative ${className} phone-avatar-video avatar-preview-video`} style={{ background: backgroundGradient, alignItems: avatarAlign, }}>
      {avatarSrc && (<img src={avatarSrc} alt="Avatar" />)}
      {audio && <audio
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "auto",
          marginBottom: "1rem",
        }}
        onClick={(event) => event.stopPropagation()}
        controls> <source src={audioSrc} type="audio/mpeg" /></audio>}
    </VerticalLayout>
  )
}


export function VideoPlayerAssessment({ src, className = "", style, onClick, openVideo }) {
  const [collapsed, setCollapsed] = useState(false);  
  if (!src) return <></>
  return (
    openVideo ? (
      <HorizontalLayout className="portrait-video-container">
        <video                onClick={(event) => event.stopPropagation()} controls className={`portrait-video standard-shadow ${className}`} src={src} />
        <IconButton style={{ position: "absolute", top: "0.5rem", right: "0.5rem" }} size={25} onClick={onClick} icon2={"x"} />
      </HorizontalLayout>
      ) : (
          <HorizontalLayout
            className={`avatar-video-container ${collapsed ? "collapsed" : ""}`}
            style={{ borderRadius: collapsed ? ".5rem" :  "0.5rem 0 0 0.5rem", }}>
            <SideIconBar exit={onClick} collapsed={collapsed} onClick={() => setCollapsed(!collapsed)} />
            {!collapsed && (
              <video
                controls
                onClick={(event) => event.stopPropagation()}
                className={`standard-shadow ${className}`}
                style={{ borderRadius: !collapsed ? ".5rem" : "0 0.5rem 0.5rem 0", }}
                src={src}
              />
            )}
          </HorizontalLayout>
        )
  )
}

const SideIconBar = ({ onClick, collapsed, exit }) => (
  <VerticalLayout className="avatar-icon-container" style={{ justifyContent: "space-between", height: "auto", minHeight: "15rem", zIndex: 3, margin: "1rem 0" }}>
    <IconButton onClick={exit} className={"maximize-icon-avatar standard-margin-top"} icon2={"maximize"} size={25} />
    <IconButton onClick={onClick} className={`avatar-icon-drop ${collapsed ? "collapsed" : ""} standard-margin-bottom`} size={25} icon2={collapsed ? "chevron-left" : "chevron-right"} />
  </VerticalLayout>
)